import React, { lazy, memo } from 'react';
import { ZapIcon, CheckIcon, PackageIcon, RefreshCwIcon, ArrowRightIcon, LockIcon, StarIcon, CheckCircleIcon } from 'lucide-react';
import { useGeoPricingContext } from '../hooks/GeoPricingContext';
export function FinalOfferSection() {
  const {
    newPrice,
    totalValue
  } = useGeoPricingContext();
  const summaryItems = [{
    name: 'Guía Completa — 370 páginas',
    value: '$97'
  }, {
    name: 'Guía Práctica',
    value: '$60'
  }, {
    name: 'Plantilla de Presupuestos',
    value: '$65'
  }, {
    name: 'Hoja de Motores',
    value: '$40'
  }, {
    name: 'Control de Ingresos',
    value: '$35'
  }, {
    name: 'Certificado',
    value: '$38'
  }, {
    name: 'Acceso de por vida',
    value: '$50+'
  }];
  return <section className="bg-brand-black-light border-t border-white/10 py-10 px-4" data-id="element-139">
      <div className="max-w-[600px] mx-auto" data-id="element-140">
        {/* Why it works */}
        <div className="text-center mb-8" data-id="element-141">
          <h2 className="text-[24px] font-bold text-brand-black mb-4 flex items-center justify-center gap-2" data-id="element-142">
            <ZapIcon className="w-6 h-6 text-primary" data-id="element-143" />
            ¿POR QUÉ ESTE SISTEMA FUNCIONA?
          </h2>
          <p className="text-dark-gray mb-6" data-id="element-144">
            Debe ser lo suficientemente claro para que lo entiendas… y lo
            suficientemente práctico para que lo uses.
          </p>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 text-left max-w-[500px] mx-auto mb-6" data-id="element-145">
            <div className="flex items-start gap-2" data-id="element-146">
              <CheckIcon className="w-5 h-5 text-success flex-shrink-0" data-id="element-147" />{' '}
              <span className="text-sm text-brand-black font-medium" data-id="element-148">
                Explicación visual paso a paso
              </span>
            </div>
            <div className="flex items-start gap-2" data-id="element-149">
              <CheckIcon className="w-5 h-5 text-success flex-shrink-0" data-id="element-150" />{' '}
              <span className="text-sm text-brand-black font-medium" data-id="element-151">
                Diagramas reales (no ejemplos vacíos)
              </span>
            </div>
            <div className="flex items-start gap-2" data-id="element-152">
              <CheckIcon className="w-5 h-5 text-success flex-shrink-0" data-id="element-153" />{' '}
              <span className="text-sm text-brand-black font-medium" data-id="element-154">
                Enfoque práctico
              </span>
            </div>
            <div className="flex items-start gap-2" data-id="element-155">
              <CheckIcon className="w-5 h-5 text-success flex-shrink-0" data-id="element-156" />{' '}
              <span className="text-sm text-brand-black font-medium" data-id="element-157">
                Herramientas listas para usar
              </span>
            </div>
          </div>
          <div className="bg-[#0B0F1A] border border-white/10 rounded-lg p-4 inline-block shadow-sm" data-id="element-158">
            <p className="text-primary font-bold m-0" data-id="element-159">
              No aprendes memorizando…
            </p>
            <p className="text-brand-black font-bold m-0 mt-1" data-id="element-160">
              Aprendes entendiendo la lógica
            </p>
          </div>
        </div>

        <h2 className="text-[26px] text-center font-bold text-brand-black mb-8 leading-[1.2] heading-underline flex items-center justify-center gap-2" data-id="element-161">
          <PackageIcon className="w-6 h-6 text-primary" data-id="element-162" />
          RESUMEN DE TODO LO QUE RECIBES
        </h2>

        {/* Hero Image */}
        <div className="mx-auto mb-8 max-w-[500px]" data-id="element-163">
          <img loading="lazy" alt="Todo lo que recibes" src="https://cdn.magicpatterns.com/uploads/jwWz5MH4t5cmno9jShCJcV/todos_los_bonos.png" className="w-full h-auto block drop-shadow-2xl" width="500" height="500" data-id="element-164" />
        </div>

        {/* Summary List */}
        <div className="bg-[#0B0F1A] border border-white/10 rounded-xl p-6 mb-8 shadow-soft" data-id="element-165">
          <div className="space-y-3 mb-6" data-id="element-166">
            {summaryItems.map((item, idx) => <div key={idx} className="flex justify-between items-center border-b border-white/5 pb-2 last:border-0 last:pb-0" data-id="element-167">
                <span className="text-brand-black font-medium text-sm" data-id="element-168">
                  {item.name}
                </span>
                <span className="text-dark-gray line-through text-sm" data-id="element-169">
                  {item.value}
                </span>
              </div>)}
          </div>

          <div className="text-center pt-4 border-t border-white/10" data-id="element-170">
            <div className="text-dark-gray text-sm uppercase tracking-wider mb-1 font-semibold" data-id="element-171">
              VALOR TOTAL:
            </div>
            <div className="text-2xl font-bold line-through text-danger mb-4" data-id="element-172">
              {totalValue}
            </div>

            <div className="text-primary font-bold text-xl mb-1" data-id="element-173">HOY:</div>
            <div className="text-[42px] font-black text-brand-black font-poppins tracking-tight mb-6" data-id="element-174">
              {newPrice}
            </div>

            {/* CTA */}
            <a href="https://dominaelcontrol.online/cart/50664044626153:1" onClick={() => window.fbq && window.fbq('track', 'AddToCart')} className="animate-pulse-big flex items-center justify-center gap-2 mx-auto bg-gradient-to-br from-success to-emerald-600 text-white border-none py-4 px-6 text-lg font-bold rounded-full cursor-pointer shadow-[0_8px_20px_rgba(34,197,94,0.3)] text-center uppercase tracking-wide no-underline hover:translate-y-[-3px] hover:scale-[1.02] hover:shadow-[0_8px_20px_rgba(34,197,94,0.4)] transition-all duration-400" data-id="element-175">
              ACCEDER AHORA MISMO
              <ArrowRightIcon className="w-5 h-5" data-id="element-176" />
            </a>
          </div>
        </div>

        <p className="text-center text-brand-black font-bold mt-6 text-lg" data-id="element-177">
          Empieza hoy… y deja de mirar diagramas sin entenderlos.
        </p>

        {/* Trust Badges */}
        <div className="flex flex-col items-center gap-2 mt-6 text-sm text-dark-gray font-medium" data-id="element-178">
          <div className="flex items-center gap-3" data-id="element-179">
            <span className="flex items-center gap-1" data-id="element-180">
              <LockIcon className="w-4 h-4 text-primary" data-id="element-181" /> Garantía 7 Días
            </span>
            <span data-id="element-182">·</span>
            <span className="flex items-center gap-1" data-id="element-183">
              <ZapIcon className="w-4 h-4 text-primary" data-id="element-184" /> Acceso Inmediato
            </span>
          </div>
          <div className="flex items-center gap-1" data-id="element-185">
            <RefreshCwIcon className="w-4 h-4 text-primary" data-id="element-186" /> Actualizaciones
            diarias de por vida
          </div>
          <div className="bg-[#1A1D24] border border-white/10 rounded-full px-4 py-1.5 flex items-center gap-2 mt-1" data-id="element-187">
            <div className="flex text-primary" data-id="element-188">
              <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-189" />
              <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-190" />
              <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-191" />
              <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-192" />
              <StarIcon className="w-3.5 h-3.5 fill-current" data-id="element-193" />
            </div>
            <span className="text-white font-bold text-xs" data-id="element-194">
              4.9/5{' '}
              <span className="text-dark-gray font-normal" data-id="element-195">
                +2.554 Electricistas
              </span>
            </span>
            <CheckCircleIcon className="w-4 h-4 text-blue-500 fill-white" data-id="element-196" />
          </div>
        </div>
      </div>
    </section>;
}